import LiveClassIndex from './index.vue';
import OfferCardsList from './OfferCards/OfferCardsList.vue';
import ClassTemplates from './ClassTemplates/';

export default {
  LiveClassIndex,
  OfferCardsList,
  ClassTemplates,
};
